export default __webpack_public_path__ + "static/banner-flight-44083e2ad12ba3565e1243d2ff3c3854.jpg";